import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import backgroundVideo from '@/images/home_background2.mp4';
const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Trigger animations after component mount
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="video-background"
        >
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      
      {/* Dark Overlay */}
      {/* <div className="absolute inset-0 bg-black/60 z-10"></div> */}
      
      {/* Content */}
      
      <div className="container mx-auto z-20 px-4 absolute bottom-20 right-0 text-right pr-8 md:pr-16">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className='text-white mb-6 font-Urbanist font-light tracking-widest'>Hello, I'm </h1>
          <h1 className="text-white mb-6 font-Urbanist font-light tracking-widest text-5xl animate-glow">
            <span className="text-primary font-Urbanist font-light tracking-widest  sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Thamodya Ranasinghe</span>
          </h1>
          
          <p className="text-white/90 text-xl md:text-2xl mx-auto mb-8 font-light tracking-widest">
          A passionate ux designer
          </p>
          
          <div className="flex gap-4 justify-end">
            <Button asChild size="lg" className="shadow-lg">
              <a href="#works">View My Work</a>
            </Button>
            <Button asChild variant="outline" size="lg" className="bg-transparent text-white border-white hover:bg-white/10">
              <a href="#contact">Contact Me</a>
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll Down Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="text-white"
        >
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <polyline points="19 12 12 19 5 12"></polyline>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
